import jwt_decode from "jwt-decode";

export default function useDecodeToken() {
  const decodeToken = () => {
    let tokenDecode = null;
    let token = JSON.parse(
      localStorage.getItem(window.brandLocalStorage)
    )?.find((o) => {
      return (
        o.brandRef ==
          new URLSearchParams(window.location.search).get("brandRef") ||
        o.brandRef == sessionStorage.getItem(window.brandSessionStorage)
      );
    })?.accessToken;
    if (token) {
      tokenDecode = jwt_decode(token);
    }
    return tokenDecode;
  };

  const decodeParamToken = () => {
    let tokenDecode = null;
    let token = new URLSearchParams(window.location.search).get("token");
    if (token) {
      tokenDecode = jwt_decode(token);
    }
    return tokenDecode;
  };

  return {
    decodeToken,
    decodeParamToken,
  };
}
